import { OrderLoyaltyReward } from '@eliadmin/core/src/components/loyalty/order-loyalty-reward';
import { ProfileRepeatOrderButton } from '@eliadmin/core/src/components/profile/profile-repeat-order-button';
import type { CustomerOrder } from '@eliadmin/core/src/api/customers/customers-types';

import { ProfileOrderDialog } from '@eliadmin/core/src/components/profile/profile-order-dialog';
import { ProfileOrderDownloadsDialog } from '@eliadmin/core/src/components/profile/profile-order-downloads-dialog';
import { ProfileOrderStatus } from '@eliadmin/core/src/components/profile/profile-order-status';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { Card, CardContent } from '@eliadmin/core/src/components/ui/card';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { formatPrice, roundPrice } from '@eliadmin/core/src/utils/price-utils';
import { FiDownload, FiSearch } from 'react-icons/fi';
import { HiOutlineArrowDownCircle } from 'react-icons/hi2';

export type ProfileOrderItemProps = {
  order: CustomerOrder;
};

//
export function ProfileOrderItem(props: ProfileOrderItemProps) {
  const locale = useLocaleStore(s => s.currentLocale);
  const currency = useGlobalStore(s => s.generalLayout.currency);
  const currencySettings = useGlobalStore(s => s.generalLayout.currency_settings);

  const { t } = useTranslations();

  return (
    <Card className="w-full rounded-[16px] bg-[#f9fafb]">
      <CardContent className="hidden flex-row items-center gap-8 p-4 lg:flex">
        <span className="w-full max-w-[150px] text-start text-base font-medium text-[#54885B]">
          #{props.order.identifier}
        </span>
        <span className="w-full max-w-[180px] text-start text-base font-normal">
          {new Date(props.order.created_at).toLocaleString(locale)}
        </span>
        <span className="w-full max-w-[222px] text-start text-base font-medium">
          {props.order.price.toFixed(2)} {currency}
        </span>
        <div className="flex w-full max-w-[287px] flex-row justify-start">
          <ProfileOrderStatus order={props.order} />
        </div>
        <ProfileOrderDialog order={props.order}>
          <Button
            size={'none'}
            variant="none"
            className="flex items-center justify-center gap-2.5 text-sm font-medium text-primary lg:text-base"
          >
            <HiOutlineArrowDownCircle size={24} /> {t('text116')}
          </Button>
        </ProfileOrderDialog>
      </CardContent>
      <CardContent className="flex flex-col items-start justify-start gap-4 rounded-[16px] bg-[#F9FAFB] p-4 w-full lg:hidden">
        <div className="flex w-full items-center justify-between">
          <p className="text-sm font-medium text-primary sm:text-base">#{props.order.identifier}</p>
          <ProfileOrderStatus order={props.order} />
        </div>
        <div className="flex w-full items-center justify-between">
          <p className="text-sm font-medium text-black sm:text-base">
            {new Date(props.order.created_at).toLocaleString(locale)}
          </p>
          <p className="text-sm font-medium text-black sm:text-base">
            {props.order.price.toFixed(2)} {currency}
          </p>
        </div>
        <ProfileOrderDialog order={props.order}>
          <Button
            size={'none'}
            variant="none"
            className="flex items-center justify-center gap-2.5 text-sm font-medium text-primary sm:text-base"
          >
            <HiOutlineArrowDownCircle size={24} /> {t('text116')}
          </Button>
        </ProfileOrderDialog>
      </CardContent>
      <ProfileRepeatOrderButton
        orderId={props.order.id}
        className="mx-4 mb-4 sm:ml-auto sm:max-w-sm"
      />

      <OrderLoyaltyReward
        reward={props.order.loyalty_reward}
        compact
        className="w-full px-4 pb-4"
      />
    </Card>
  );
}
